module.exports = __webpack_public_path__ + "ipetbooking-build/img/no-record.dade0a24.svg";